<template>
  <div class="row q-gutter-sm q-mb-md">
    <Selector
      :options="dashboardOptions"
      v-model="dashboardId"
      :useInput="false"
      style="width: 300px"
      bg-color="transparent"
      label-has-badge
    />
    <Button
      :label="$t('Edit dashboard')"
      color="primary"
      icon="edit"
      @click="openDialogEditDashboard"
      outline
    />
    <Button :label="$t('Save this view')" color="primary" icon="save" @click="saveView" />
    <Space />
    <Button
      :label="$t('Create new dashboard')"
      color="primary"
      icon="add"
      @click="openDialogCreateDashboard"
    />

    <DialogCreateDashboard :visible.sync="visibleDialogCreateDashboard" v-on="$listeners" />
    <DialogEditDashboard :visible.sync="visibleDialogEditDashboard" v-on="$listeners" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Selector from '@design-system/components/Selector';
import Button from '@design-system/components/Button';
import Space from '@design-system/components/Space';
import DialogCreateDashboard from './DialogCreateDashboard';
import DialogEditDashboard from './DialogEditDashboard';

const messages = {
  en: {
    'Create new dashboard': 'Create new dashboard',
    'Save this view': 'Save this view',
    Edit: 'Edit',
  },
  ja: {
    'Create new dashboard': 'ダッシュボード追加',
    'Save this view': 'ビュー保存',
    Edit: '更新',
  },
};

export default {
  name: 'HeadContents',
  components: { Button, Space, Selector, DialogCreateDashboard, DialogEditDashboard },
  i18n: { messages },
  data() {
    return {
      visibleDialogCreateDashboard: false,
      visibleDialogEditDashboard: false,
    };
  },
  computed: {
    ...mapGetters('dashboard', {
      dashboardOptions: 'dashboardOptions',
      currentDashboardId: 'currentDashboardId',
      currentDashboard: 'currentDashboard',
      layout: 'layout',
    }),

    dashboardId: {
      set(val) {
        this.updateCurrentDashboardId(val);
      },
      get() {
        return this.currentDashboardId;
      },
    },
  },
  methods: {
    ...mapActions('dashboard', {
      saveDashboard: 'saveDashboard',
    }),
    ...mapMutations('dashboard', {
      updateCurrentDashboardId: 'updateCurrentDashboardId',
    }),
    openDialogCreateDashboard() {
      this.visibleDialogCreateDashboard = true;
    },
    openDialogEditDashboard() {
      this.visibleDialogEditDashboard = true;
    },
    saveView() {
      const dashboard = {
        id: this.currentDashboardId,
        name: this.currentDashboard.name,
        isPublic: this.currentDashboard.isPublic,
        widgets: this.layout.map(item => ({
          widget: item.widget,
          x: item.x,
          y: item.y,
          h: item.h,
          w: item.w,
          i: item.i,
          static: item.static,
          settings: item.settings,
        })),
      };

      this.saveDashboard(dashboard);
    },
  },
};
</script>

<style lang="scss" scoped></style>
